import React from 'react';

const TechStackSlider = () => {
  const technologies = [
    { 
      name: 'React', 
      icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg',
      description: 'Interfaces modernas',
      color: '#61DAFB'
    },
    { 
      name: 'Node.js', 
      icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg',
      description: 'Backend escalable',
      color: '#339933'
    },
    { 
      name: 'AWS', 
      icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg',
      description: 'Cloud infrastructure',
      color: '#FF9900'
    },
    { 
      name: 'PostgreSQL', 
      icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg',
      description: 'Bases de datos',
      color: '#4169E1'
    },
    { 
      name: 'Python', 
      icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg',
      description: 'IA & ML',
      color: '#3776AB'
    },
    { 
      name: 'Docker', 
      icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg',
      description: 'Contenedores',
      color: '#2496ED'
    },
    { 
      name: 'Vue.js', 
      icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg',
      description: 'Framework web',
      color: '#4FC08D'
    },
    { 
      name: 'TensorFlow', 
      icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg',
      description: 'Machine Learning',
      color: '#FF6F00'
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-gray-900">Tecnologías de </span>
            <span className="bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">Vanguardia</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-cyan-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Utilizamos las herramientas más avanzadas del mercado para garantizar soluciones robustas y escalables
          </p>
        </div>

        {/* Infinite Scroll Container */}
        <div className="relative">
          <div className="flex animate-scroll-infinite-slow">
            {/* First set */}
            {technologies.map((tech, index) => (
              <div
                key={`tech-1-${index}`}
                className="flex-shrink-0 mx-4"
                style={{ width: '200px' }}
              >
                <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 group">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                    <img 
                      src={tech.icon} 
                      alt={tech.name}
                      className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2 text-center">
                    {tech.name}
                  </h3>
                  <p className="text-sm text-gray-600 text-center">
                    {tech.description}
                  </p>
                </div>
              </div>
            ))}
            {/* Duplicate for infinite scroll */}
            {technologies.map((tech, index) => (
              <div
                key={`tech-2-${index}`}
                className="flex-shrink-0 mx-4"
                style={{ width: '200px' }}
              >
                <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 group">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                    <img 
                      src={tech.icon} 
                      alt={tech.name}
                      className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2 text-center">
                    {tech.name}
                  </h3>
                  <p className="text-sm text-gray-600 text-center">
                    {tech.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechStackSlider;
